// extracted by css-extract-rspack-plugin
export default {"dialog":"ResolveConflictsDialog-module__dialog__JCW3L","codeBlock":"ResolveConflictsDialog-module__codeBlock__mDwzj"};